<template>
  <b-modal
    id="editDirectionExamModal"
    size="lg"
    :title="title"
    @show="updateData"
    @ok="onSave"
  >
    <b-form-group label="Предмет ЕГЭ">
      <MultiSelect
        required
        :value="formData.subject"
        :options="subjectsForSelect"
        label="name"
        @input="onSelectSubject"
      />
    </b-form-group>
    <div class="d-flex">
      <div class="w-50 mr-2">
        <b-form-group label="Номер">
          <b-form-input
            required
            min="0"
            max="100"
            type="number"
            oninput="this.value = this.value.replaceAll(/[^0-9]/g, '')"
            v-model="formData.directionUniversitySubject.order"
          />
        </b-form-group>
      </div>
      <div class="w-50">
        <b-form-group label="Минимальный балл">
          <b-form-input
            required
            min="0"
            max="100"
            type="number"
            v-model="formData.directionUniversitySubject.minimalMark"
          />
        </b-form-group>
      </div>
    </div>
    <b-form-checkbox class="mt-2" v-model="formData.directionUniversitySubject.isProfile">
      Профильный
    </b-form-checkbox>
    <b-alert show class="mt-2" variant="danger" v-if="!isCorrectMark">
      Минимальный балл должен быть от 0 до 100
    </b-alert>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button @click="ok" variant="primary" :disabled="isDisabled">
        Сохранить
      </b-button>
      <b-button variant="outline-primary" @click="cancel">
        Отмена
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import _ from 'lodash'
import MultiSelect from '@/components/ui/MultiSelect.vue'
import RecommendationAPI from '@/api/recommendation'

export default {
  name: 'EditDirectionExamModal',
  components: {
    MultiSelect
  },
  props: {
    editData: {
      type: Object,
      default: null
    },
    selectedExams: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    editData: {
      deep: true,
      handler() {
        this.updateData()
      }
    }
  },
  data() {
    return {
      title: '',
      addTitle: 'Добавление предмета ЕГЭ для направления',
      editTitle: 'Редактирование предмета ЕГЭ для направления',
      formData: {
        id: null,
        directionUniversitySubject: {
          order: 0,
          minimalMark: 0,
          isProfile: false
        },
        subject: []
      },
      subjects: []
    }
  },
  computed: {
    subjectsForSelect() {
      return this.subjects.filter((s) => !this.selectedExams.includes(s.name)
        || (this.editData && this.editData.id === s.id))
    },
    isDisabled() {
      return !(this.formData && this.formData.subject
        && this.isCorrectMark
        && this.formData.directionUniversitySubject.order
      )
    },
    isCorrectMark() {
      return this.formData.directionUniversitySubject.minimalMark
        && this.formData.directionUniversitySubject.minimalMark <= 100
        && this.formData.directionUniversitySubject.minimalMark >= 0
    }
  },
  async created() {
    const response = await RecommendationAPI.getExamSubjects()
    this.subjects = _.sortBy(response.data, 'name')
  },
  methods: {
    updateData() {
      this.formData = _.cloneDeep(this.editData) || this.clearData()
      this.formData.subject = this.editData
        ? [this.subjects.find((s) => s.id === this.editData.id)]
        : null
      this.title = this.editData ? this.editTitle : this.addTitle
    },
    onSelectSubject(data) {
      this.formData.subject = [data]
    },
    onSelectOlympiad(data) {
      if (!data.length) {
        this.formData.directionUniversitySubject.addMark = 0
      }
      this.formData.directionUniversitySubject.olympiad = data
    },
    onSave() {
      this.$emit('save', {
        ...this.formData,
        ...this.formData.subject[0]
      })
    },
    clearData() {
      return {
        subject: [],
        directionUniversitySubject: {
          order: 0,
          minimalMark: 0,
          isProfile: false
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
